import { render, staticRenderFns } from "./SchoolDetail.vue?vue&type=template&id=053f342e&scoped=true&"
import script from "./SchoolDetail.vue?vue&type=script&lang=js&"
export * from "./SchoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDetail.vue?vue&type=style&index=0&id=053f342e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f342e",
  null
  
)

export default component.exports